import { Route } from "react-router-dom";

import HomeNarrator from "../pages/HomeNarrator";
import HomeProducer from "../pages/HomeProducer";
import HomePublisher from "../pages/HomePublisher";
import HomeSuperAdmin from "../pages/HomeSuperAdmin";

export const homeProducer = <Route index element={<HomeProducer />} />;

export const homePublisher = <Route index element={<HomePublisher />} />;

export const homeSuperAdmin = <Route index element={<HomeSuperAdmin />} />;

export const homeNarrator = <Route index element={<HomeNarrator />} />;
